import React from "react";

import Pagination from "@mui/material/Pagination";

interface Props {
  page: number;
  totalItems: number;
  handleChangePage: (page: number) => void;
  defaultPageSize: number;
}

const CommonPagination = ({ page, handleChangePage, totalItems, defaultPageSize }: Props) => {
  return (
    <Pagination
      page={page}
      count={totalItems ? Math.ceil(totalItems / defaultPageSize) : 0}
      onChange={(_, page) => handleChangePage(page)}
      siblingCount={0}
    />
  );
};

export default CommonPagination;
